export const handleClickCommon = (event, onClick) => {
  if (onClick) {
    event.preventDefault();
    event.stopPropagation();
    onClick(event);
  }
};